import { ref, computed, type ComputedRef } from 'vue'
import type { ExtendedBlock } from 'widget-components'
import { flattenBlocks } from 'widget-components/utilities/containers/flatten-blocks'
import { findBlockPathById } from './utilities/findBlockPathById'
import { assocPath } from 'ramda'

const _blocks = ref<ExtendedBlock[]>([])

export const blocks: ComputedRef<ExtendedBlock[]> = computed(() => _blocks.value)
export const flattenedBlocks = computed(() => flattenBlocks(_blocks.value))

export const setBlocks = (blocks: ExtendedBlock[]) => {
    _blocks.value = blocks
}

export const updateBlock = (block: ExtendedBlock) => {
    const blockPath = block.blockPath || findBlockPathById(block.id)
    if (!blockPath) {
        return
    }
    _blocks.value = assocPath(blockPath, block, _blocks.value)
}
